/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable template-curly-spacing */
import React, { Component } from 'react';
import moment from 'moment';
import Table from '../component/Table';
import { confirmedAlert } from '../component/Alert';
import Alert from 'view/component/Alert';
import API from '../../apiService';
import ModalAdd from './modalAdd';

export default class sanitasi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      isLoading: true,
      modalShow: false,
      data: {
        id: null,
        visit_id: this.props.detilPx.id,
        type: 'patient',
        counseling_problem: '',
        counseling_suggestion: '',
        inspection_date: moment().format('YYYY-MM-DD'),
        inspection_result: '',
        inspection_intervention: '',
        description: '',
      },
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const res = await API.post(`registration/kesling/read?group=sanitasi&patient_id=${this.props.detilPx.patient_id}`);
    if (res.code === 200) this.setState({ datas: res.data, isLoading: false });
    else this.setState({ isLoading: false });
  };

  deleteData = async (id) => {
    const res = await API.delete(`registration/kesling/delete/${id}`);
    if (res.code === 200) {
      Alert('success', 'data dihapus');
      this.getData();
    }
    else Alert('error', 'gagal menghapus data');
  };

  createActionButton = (data) => {
    return (
      <div>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => this.setState({ data, modalShow: true })}>
          Edit
        </button>
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => confirmedAlert(
            'Konfirmasi',
            'Apakah anda akan menghapus data status kesehatan lingkungan?',
            confirmed => {
              if (confirmed) this.deleteData(data.id);
            }
          )}>
          Hapus
        </button>
      </div>
    );
  }

  render() {
    const { datas, isLoading, data, modalShow } = this.state;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Data Sanitasi</h4>
              </div>
              <div className="col-4 text-right">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  data-toggle="collapse"
                  data-target="#collapsePreview"
                  aria-expanded="false"
                  aria-controls="collapsePreview"
                  onClick={() => this.setState({ modalShow: true })}
                >
                  <span className="btn-inner--text">Tambah Data</span>
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className='col-12'>
                <Table
                  headers={[
                    'No',
                    'tanggal',
                    'tipe',
                    'kondisi/masalah',
                    'saran/rekomendasi',
                    'tanggal inspeksi',
                    'hasil inspeksi',
                    'intervensi',
                    'keterangan',
                    'petugas',
                    'Aksi',
                  ]}
                  isLoading={isLoading}
                  data={datas}
                  columnMapper={(item) => [
                    moment(item.created_at).format('DD-MM-YYYY HH:mm'),
                    item.type === 'patient' ? 'Pasien' : 'Klien',
                    item.counseling_problem,
                    item.counseling_suggestion,
                    moment(item.inspection_date).format('DD-MM-YYYY'),
                    item.inspection_result,
                    item.inspection_intervention,
                    item.description,
                    item.user && item.user.name,
                    this.createActionButton(item),
                  ]}
                  pagination={true}
                />
              </div>
            </div>
          </div>
        </div>
        <ModalAdd
          data={data}
          show={modalShow}
          onHide={() => {
            this.setState({ modalShow: false })
            this.getData();
          }}
        />
      </div>
    );
  }
}
